import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable, of } from 'rxjs';
import { TaskWriteDTO, TaskDTO } from '../interfaces/task';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private dataService: DataService) { }

  saveTask(taskId: number, task: TaskWriteDTO): Observable<TaskDTO> {
    if (taskId && taskId > 0) {
      return this.dataService.updateTask(taskId, task);
    } else {
      return this.dataService.createTask(task);
    }
  }

  deleteTask(task: TaskDTO): Observable<any> {
    if (task && task.id != null && task.id > 0) {
      return this.dataService.deleteTask(task.id);
    } else return of(null);
  }

  getTasks(calendarId: number, status: string): Observable<any> {
    return this.dataService.getTasks(calendarId, status);
  }

  getTask(taskId: number): Observable<any> {
    return this.dataService.getTask(taskId);
  }

  getNumberOfTasksForNote(noteId: number): Observable<any> {
    return this.dataService.getNumberOfTasksForNote(noteId);
  }

  getTasksForDueDate(calendarId: number, dueDate: Date): Observable<any> {
    return this.dataService.getTasksForDueDate(calendarId, dueDate.toISOString());
  }
}
